import { Button, Tooltip } from '@pwc/pwc-deals-ui';
import { useTranslation } from 'react-i18next';
import MoreMenu from 'common/components/ContentActions/MoreMenu';
import { reportTopicsPreviewPath } from 'common/services/urlService';

import { USER_ROLES } from '@pwc/pwc-deals-web-common';
import { useSelector } from 'react-redux';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import useMobile from 'common/hooks/useMobile';

type ViewClient = {
  isOnClientVersion: boolean;
};

type Topic = {
  content: {
    contentId: string;
    contentThreadId: string;
    versionStatus: string;
  };
};

type Props = {
  projectId: string;
  isProjectDisabled: boolean;
  isLoading: boolean;
  isDisabled: boolean;
  lockingUserName: string;
  onEdit: () => void;
  onDelete: () => void;
  topic: Topic;
  workflowActions: unknown;
  viewClient: ViewClient;
};
const TopicActionPanel = (props: Props) => {
  const { t } = useTranslation();
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;

  const {
    projectId,
    onEdit,
    onDelete,
    isProjectDisabled,
    isLoading,
    isDisabled,
    lockingUserName,
    topic,
    workflowActions,
    viewClient,
  } = props;
  const isMobile = useMobile();
  const DisabledClientEditButton = (
    <Tooltip
      direction="bottom"
      tip="Unable to edit in client draft mode. Please switch to in progress mode to make changes."
      dataTestId={undefined}
      unthemed={undefined}
      showingInitial={undefined}
    >
      <Button
        data-testid="topic-edit-button"
        type="button"
        className="button-block button-small mr-3"
        disabled
        icon={undefined}
        iconClasses={undefined}
      >
        Edit
      </Button>
    </Tooltip>
  );

  const EditButton = (disabled: boolean) => {
    return (
      <Button
        data-testid="topic-edit-button"
        type="button"
        onClick={onEdit}
        className="button-block button-small"
        disabled={disabled}
        icon={undefined}
        iconClasses={undefined}
      >
        Edit
      </Button>
    );
  };

  return (
    <div className="autoLock-container">
      <div className="topic-edit-button">
        {!viewClient.isOnClientVersion && isDisabled && lockingUserName ? (
          <Tooltip
            direction="bottom-end"
            tip={`${t('unableToEditAs')} ${lockingUserName} ${t(
              'isCurrentlyEditing'
            )}`}
            dataTestId={`user-${lockingUserName}-test-id`}
            unthemed={undefined}
            showingInitial={undefined}
          >
            {EditButton(
              isProjectDisabled || isLoading || isDisabled || isMobile
            )}
          </Tooltip>
        ) : (
          <>
            {!viewClient.isOnClientVersion &&
              EditButton(isProjectDisabled || isLoading || isMobile)}
            {viewClient.isOnClientVersion && DisabledClientEditButton}
          </>
        )}
      </div>
      <div className="more-menu">
        <MoreMenu
          itemId={topic.content.contentId}
          onDelete={onDelete}
          workflowActions={workflowActions}
          viewClient={viewClient}
          reportPreviewUrl={reportTopicsPreviewPath(
            projectId,
            topic.content.contentThreadId,
            topic.content.versionStatus,
            isPwcUser
          )}
          isTopicHeader
          isDisabled={isDisabled}
          onRefresh={undefined}
          onEdit={undefined}
        />
      </div>
    </div>
  );
};

export default TopicActionPanel;
